import React, {useState, useEffect, useRef}  from 'react';
import { useDispatch, useSelector } from "react-redux";
import Layout from "../../layout/Layout";
import moment from 'moment';

import { listsetting1, useropen } from '../../redux/userInfo';
import { open, close, loadingflas, listupdater } from '../../redux/popupSlice';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import Button from '../../component/Button';
import Select from '../../component/Select';
import Radios from '../../component/Radios';
import Input from '../../component/Input';
import ListsettingPop from '../../component/ListsettingPop';
import ProductDetailPop from '../../component/ProductDetailPop';
import ProductSendPop from '../../component/ProductSendPop';
import ProductTogetherPop from '../../component/ProductTogetherPop';

import { Map, DrawingManager, MarkerClusterer, MapMarker, CustomOverlayMap } from "react-kakao-maps-sdk"
import AddrSelector from '../../component/AddrSelector';
import * as APIS from "../../utils/service";

import { getMemberinfo, numFormat, useIntersectionObserver, polygon_point_check, filterItems, filterItemsProduct } from "../../utils/utils";
import Checkbox from '../../component/Checkbox';
import consts from '../../libs/consts';
import ProductDetailwrite from '../../component/ProductDetailwrite';

const { kakao } = window;



export default function Product({ navigation,  }) {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const managerRef = useRef(null);
    const mapRef = useRef(null);
    const clusterer = useRef(null);
    const target = useRef(null);
    const leftdivref = useRef(null);
    const { configdata } = useSelector(s => s.configReducer);
    const { listupdate } = useSelector(s => s.popupReducer);
    const [customerlist, setcustomerlist] = useState([]);
    const [customerselect, setcustomerselect] = useState([]);
    const location = useLocation();


    // setproductIdx(x?.idx);
    // setproductdetailflag(true);


    let statusArrs = [];
    configdata?.consts?.itemStatusConsts?.map((x, i) => {
        if(x?.idx*1 === 98){
            statusArrs.push({idx: x?.idx, title: x?.title, arrays: [x?.title, 'green', 'no', x?.idx], labels: x?.title, values: x?.idx});
        } else if(x?.idx*1 === 1){
            statusArrs.push({idx: x?.idx, title: x?.title, arrays: [x?.title, 'black', 'y', x?.idx], labels: x?.title, values: x?.idx});
        } else if(x?.idx*1 === 2){
            statusArrs.push({idx: x?.idx, title: x?.title, arrays: [x?.title, 'blue', 'y', x?.idx], labels: x?.title, values: x?.idx});
        } else if(x?.idx*1 === 3){
            statusArrs.push({idx: x?.idx, title: x?.title, arrays: [x?.title, 'red', 'y', x?.idx], labels: x?.title, values: x?.idx});
        } else {
            statusArrs.push({idx: x?.idx, title: x?.title, arrays: [x?.title, 'gray', 'y', x?.idx], labels: x?.title, values: x?.idx});
        }
    });
    // {'set': ['접수', 'black', 'y'], '매물번호': '2153151', '접수일': '23/12/02', '확인일': '7일전', '읍/면,동': '성산동', '지번': '123-1', '전용': '17평', '종류': '월세', '가격': '4,000/210', '관리비': '60' },
    // {'set': ['간편', 'green', 'no'], '매물번호': '2153151', '접수일': '23/12/02', '확인일': '7일전', '읍/면,동': '성산동', '지번': '123-1', '전용': '17평', '종류': '월세', '가격': '4,000/210', '관리비': '60' },
    // {'set': ['임장', 'blue', 'y'], '매물번호': '2153151', '접수일': '23/12/02', '확인일': '7일전', '읍/면,동': '성산동', '지번': '123-1', '전용': '17평', '종류': '월세', '가격': '4,000/210', '관리비': '60' },
    // {'set': ['보류', 'red', 'y'], '매물번호': '2153151', '접수일': '23/12/02', '확인일': '7일전', '읍/면,동': '성산동', '지번': '123-1', '전용': '17평', '종류': '월세', '가격': '4,000/210', '관리비': '60' },
    // {'set': ['의뢰', 'orange', 'no'], '매물번호': '2153151', '접수일': '23/12/02', '확인일': '7일전', '읍/면,동': '성산동', '지번': '123-1', '전용': '17평', '종류': '월세', '가격': '4,000/210', '관리비': '60' },
    // {'set': ['완료', 'gray', 'y'], '매물번호': '2153151', '접수일': '23/12/02', '확인일': '7일전', '읍/면,동': '성산동', '지번': '123-1', '전용': '17평', '종류': '월세', '가격': '4,000/210', '관리비': '60' },

    const statusName = statusArrs;


    const { seltypes, category_1s, 
        listset1, 
        listset2, 
        listset3, 
        listset1_2, 
        listset2_2, 
        listset3_2, 
        listset1_3, 
        listset2_3, 
        listset3_3, 
    } = useSelector(state => state.userInfo);

    const width = window.innerWidth;
    const height = window.innerHeight;



    const MIN_WIDTH = width/2;
    const [memberinfos, setmemberinfos] = useState(''); 
    const [searchwidth, setsearchwidth] = useState(MIN_WIDTH);   
    const [searchwidth2, setsearchwidth2] = useState('100%');   
    const [moverleft, setmoverleft] = useState(MIN_WIDTH-14);   
    const [searchactive, setsearchactive] = useState(0);   
    const [radio1, setradio1] = useState(0);   
    const [searchvar, setsearchvar] = useState('');   
    const [selectorderby, setselectorderby] = useState('');   
    const [listsetbuttonactive, setlistsetbuttonactive] = useState(false);   
    const [productdetailflag, setproductdetailflag] = useState(false);   
    const [productsendflag, setproductsendflag] = useState(false);   
    const [producttogetherflag, setproducttogetherflag] = useState(false);   
    const [productIdx, setproductIdx] = useState(0);   
    const [togetherinfoData, settogetherinfoData] = useState({});   
    const [clurChk, setclurChk] = useState(false);
    
    const [sell_type, setsell_type] = useState('');   

    const [pricemin, setpricemin] = useState('');   
    const [pricemax, setpricemax] = useState('');   
    const [areamin, setareamin] = useState('');   
    const [areamax, setareamax] = useState('');   
    const [latlng, setlatlng] = useState({lat: 33.450701, lng: 126.570667 });   
    const [polygons, setpolygons] = useState([]);   
    const [positions, setpositions] = useState([]);   
    const [seldamdang, setseldamdang] = useState(0); 
    const [damdanglist, setdamdanglist] = useState([]); 
    const [SendDatas, setSendDatas] = useState({}); 
    const [row, setrow] = useState({}); 
    const [popflag, setpopflag] = useState(false); 
    const [mobilesearchviewflag, setmobilesearchviewflag] = useState(false); 

    // area 평=1 제곱미터=2
    const [areatype, setareatype] = useState(1);
    
    useEffect(() => {
        // 페이지 렌더링 초기에 설정
        if(seltypes){
            if(seltypes*1 === 2){
                setsell_type('전세');
                setproductlistTh(listset1_2?.filter(item => item?.sellstatus === true));
            } else if(seltypes*1 === 3){
                setsell_type('월세');
                setproductlistTh(listset1_3?.filter(item => item?.sellstatus === true));
            } else {
                setsell_type('매매');
                setproductlistTh(listset1?.filter(item => item?.sellstatus === true));
            }
        }
        if(category_1s){
            setcategory_1(category_1s);
            setcategory_2(0);
        }

        getMemberinfo((e) => {
            setmemberinfos(e);
            setseldamdang(e?.idx*1);
        }, true);
    }, []); 

    useEffect(() => {
        if(location?.state?.itemIdx*1 > 0){
            setproductIdx(location?.state?.itemIdx);
            setproductdetailflag(true);
        }
    }, [location?.state?.itemIdx]);

    useEffect(()=>{
        if (location?.state?.type === "insertProduct"){
            console.log("type insertProduct",location?.state)
            setTimeout(() => {
                setsell_type(location?.state?.sell_type);
                setcategory_1(location?.state?.category_1);
                setcategory_2(0);
            },500)
        }
    },[location?.state])

    useEffect(() => {
        if(memberinfos?.compony?.addr){
            let address = memberinfos?.compony?.addr;
            const geocoder = new window.kakao.maps.services.Geocoder();
            geocoder.addressSearch(address, function (result, status) {
              if (status === window.kakao.maps.services.Status.OK) {
                const coords = new window.kakao.maps.LatLng(result[0].y, result[0].x);
                //console.log(result[0].y, result[0].x);
                setlatlng({lat: result[0].y, lng: result[0].x });
              }
            });
        }
    }, [memberinfos]);

    let category_1_setting = configdata?.consts?.category_1_OptionConsts?.map((x, i) => {
        return {names: x?.title, values: x?.idx}
    })
    let category_2_setting = configdata?.consts?.category_2_OptionConsts?.map((x, i) => {
        return {names: x?.title, values: x?.idx, category_1: x?.category_1}
    })
    let category_1_setting2 = configdata?.consts?.category_1_OptionConsts?.map((x, i) => {
        return {labels: x?.title, values: x?.idx}
    })
    let category_2_setting2 = configdata?.consts?.category_2_OptionConsts?.map((x, i) => {
        return {labels: x?.title, values: x?.idx, category_1: x?.category_1}
    })

    //console.log(category_1_setting2);
    const [category_1_OptionConsts, setcategory_1_OptionConsts] = useState(category_1_setting);   
    const [category_2_OptionConsts, setcategory_2_OptionConsts] = useState(category_2_setting);   


    let firstCategorys = configdata?.consts?.category_1_OptionConsts?.find((x, i) => i === 0)?.idx;
    // console.log(firstCategorys);
    const [category_1, setcategory_1] = useState(firstCategorys);   
    //const [category_2, setcategory_2] = useState(configdata?.consts?.category_2_OptionConsts?.find((x, i) => (x?.category_1 === firstCategorys && i === 0))?.idx); 
    const [category_2, setcategory_2] = useState(0); 
    const [checkvalues, setcheckvalues] = useState([]);   


    const [listselecterviewerlist, setlistselecterviewerlist] = useState([]);   
    
    const [productlistTh, setproductlistTh] = useState(listset1?.filter(item => item?.sellstatus === true));   
    const [productlistTd, setproductlistTd] = useState([]);   
    const [saveproductlistTd, setsaveproductlistTd] = useState([]);   
    
    const [polystatus, setpolystatus] = useState(false);   
    const [listsetpopstatus, setlistsetpopstatus] = useState(false);   

    const [page, setPage] = useState(0);   
    const [lists, setlists] = useState([]); 
    const [listloading, setlistloading] = useState(false); 

    const [ordercreatedt, setordercreatedt] = useState(0);   
    const [detailwrite, setdetailwrite] = useState(false);   
    const [updatestatus, setupdatestatus] = useState(false); 
    const [listDataAll, setlistDataAll] = useState([]); 

    const [mapViewerflag, setmapViewerflag] = useState(false); 
    const [loadingstep, setloadingstep] = useState(0); 

    
    const [observe, unobserve] = useIntersectionObserver(() => {
        setPage((page) => page + 1);
    });
    
    useEffect(() => {
        if(loadingstep === 0){
            let sender = {}
            APIS.postData('/v1/master/users', sender).then(({ data }) => {
                if(data){
                    //setdamdanglist(data);
                    //console.log(data);
                    let damdanglistArr = [];
                    data?.map((x, i) => {
                        damdanglistArr.push({labels: `${x?.name} ${x?.rank}`, values: x?.idx});
                    })
                    setdamdanglist(damdanglistArr);
                    setTimeout(() => {
                        setloadingstep(1);
                    }, 200);
                }
            }).catch(({ response }) => {
                const { data } = response;
                setTimeout(() => {
                    setloadingstep(1);
                }, 200);
            }).finally(() => {
            });  
        }
        if(loadingstep === 1){
            //console.log("seltypesseltypesseltypesseltypes", seltypes);
            if(seltypes){
                if(seltypes*1 === 2){
                    setsell_type('전세');
                    setproductlistTh(listset1_2?.filter(item => item?.sellstatus === true));
                } else if(seltypes*1 === 3){
                    setsell_type('월세');
                    setproductlistTh(listset1_3?.filter(item => item?.sellstatus === true));
                } else {
                    setsell_type('매매');
                    setproductlistTh(listset1?.filter(item => item?.sellstatus === true));
                }
            }
            if(category_1s){
                // 상세화면 갔다 뒤로 갈ㄸㅒ 자꾸 초기화 해서 없에버림
                // setcategory_1(category_1s);
                // setcategory_2(0);
            }
            setPage(1);
            observe(target.current);
            setTimeout(() => {
                setloadingstep(2);
            }, 200);
        }
        if(loadingstep === 2){
            let listData = []
            if(sell_type === '전세'){
                if(category_1*1 === 2){
                    listData = listset2_2?.filter(item => item?.sellstatus === true);
                } else if(category_1*1 === 3) {
                    listData = listset3_2?.filter(item => item?.sellstatus === true);
                } else {
                    listData = listset1_2?.filter(item => item?.sellstatus === true);
                }
            } else if(sell_type === '월세'){
                if(category_1*1 === 2){
                    listData = listset2_3?.filter(item => item?.sellstatus === true);
                } else if(category_1*1 === 3) {
                    listData = listset3_3?.filter(item => item?.sellstatus === true);
                } else {
                    listData = listset1_3?.filter(item => item?.sellstatus === true);
                }
            } else {
                if(category_1 === 2){
                    listData = listset2?.filter(item => item?.sellstatus === true);
                } else if(category_1*1 === 3) {
                    listData = listset3?.filter(item => item?.sellstatus === true);
                } else {
                    listData = listset1?.filter(item => item?.sellstatus === true);
                }
            }
            
            // listData.push({
            //     selltypeCker: [1,2,3],
            //     sellstatus: true,
            //     key: 'mediation',
            //     viewernames: '공동중개',
            //     disabled: true
            // })
            setproductlistTh(listData)
            setloadingstep(3);
        }
        if(loadingstep === 3){
            setTimeout(() => {
                if(listupdate === true){
                    dispatch(listupdater({ listupdate: false }));
                    listopen();
                } else {
                    listopen();
                    setPage(1);
                    observe(target?.current);    
                }
            }, 200);            
        }
    }, [loadingstep]);

    useEffect(() => {
        if(loadingstep === 4){
            setloadingstep(1);
        }
    }, [listset1, listset2, listset3, listset1_2, listset2_2, listset3_2, listset1_3, listset2_3, listset3_3 ]);
    

    useEffect(() => {
        if(loadingstep === 4){
            setloadingstep(2);
        }
    }, [category_1, sell_type, listupdate]);

    const searchlistSet = () => {
        setpositions([]);
        clusterer?.current?.clear();
        //if(polystatus === false){
            setlistloading(true);
            setTimeout(() => {
                const map = mapRef?.current;
                //map?.setLevel(4);
                setTimeout(() => {
                    searchSetlist();
                }, 300);
            }, 200);
        //}
    }

    useEffect(() => {
        searchlistSet();
    }, [
        saveproductlistTd, ordercreatedt, checkvalues, category_2, searchvar, listselecterviewerlist, 
        pricemin, pricemax, areamin, areamax, selectorderby, polygons, polystatus, seldamdang
    ]);
    const searchSetlist = () => {
        let listSearchArr = saveproductlistTd;
        if(saveproductlistTd?.length > 0){
            listSearchArr = listSearchArr?.filter(item => item?.sell_type === sell_type);
        }
        if(ordercreatedt*1 === 0){
            listSearchArr = listSearchArr.sort(function (a, b) {
                if(a.hasOwnProperty('idx')){
                    return b.idx - a.idx;
                }
            });
        }
        if(ordercreatedt*1 === 1){
            listSearchArr = listSearchArr.sort(function (a, b) {
                if(a.hasOwnProperty('idx')){
                    return a.idx - b.idx;
                }
            });
        }
        if(ordercreatedt*1 === 2){
            listSearchArr = listSearchArr.sort(function (a, b) {
                if(a.hasOwnProperty('orderupdatedt')){
                    return a.orderupdatedt - b.orderupdatedt;
                }
            });
        }
        if(ordercreatedt*1 === 3){
            listSearchArr = listSearchArr.sort(function (a, b) {
                if(a.hasOwnProperty('orderupdatedt')){
                    return b.orderupdatedt - a.orderupdatedt;
                }
            });
        }
        if(ordercreatedt*1 === 4){
            listSearchArr = listSearchArr.sort(function (a, b) {
                if(a.hasOwnProperty('orderprice_sell')){
                    return a.orderprice_sell - b.orderprice_sell;
                }
            });
        }
        if(ordercreatedt*1 === 5){
            listSearchArr = listSearchArr.sort(function (a, b) {
                if(a.hasOwnProperty('orderprice_sell')){
                    return b.orderprice_sell - a.orderprice_sell;
                }
            });
        }
        if(ordercreatedt*1 === 6){
            listSearchArr = listSearchArr.sort(function (a, b) {
                if(a.hasOwnProperty('orderarea_private')){
                    return a.orderarea_private - b.orderarea_private;
                }
            });
        }
        if(ordercreatedt*1 === 7){
            listSearchArr = listSearchArr.sort(function (a, b) {
                if(a.hasOwnProperty('orderarea_private')){
                    return b.orderarea_private - a.orderarea_private;
                }
            });
        }
        if(checkvalues?.length > 0){
            //listSearchArr = listSearchArr?.filter(item => item?.statusname === '완료');
            listSearchArr = listSearchArr?.filter(item => (item?.mediations1 > 0 || item?.mediations2 > 0));
        }
        if(category_1){
            listSearchArr = listSearchArr?.filter(item => item?.category_1*1 === category_1*1);
        }
        if(category_2){
            listSearchArr = listSearchArr?.filter(item => item?.category_2*1 === category_2*1);
        }
        if(searchvar){
            listSearchArr = listSearchArr?.filter(item => (
                item?.productcode?.includes(searchvar) ||
                item?.ordertitle?.includes(searchvar) ||
                item?.ordersigungu?.includes(searchvar) ||
                item?.orderdong?.includes(searchvar) ||
                item?.orderjibun?.includes(searchvar) ||
                item?.client_hp?.includes(searchvar) ||
                item?.desc?.includes(searchvar) ||
                item?.item_usage?.includes(searchvar)
            ));
        }


        if(listselecterviewerlist?.length > 0){
            console.log(listselecterviewerlist);
            console.log(listselecterviewerlist?.map(item => item.viewernames)?.join(","));

            //listSearchArr = listSearchArr?.filter(item => item?.dong?.includes('오치동','연제동','용강동') > 0);
            let arrlists = [];
            listselecterviewerlist?.map((x, i) => {
                listSearchArr?.filter(item => {
                    let setsigunguex = x?.viewernames?.split(' ');
                    if(x?.viewernames?.includes('전체')){
                        //console.log(setsigunguex, item?.ordersigungu, setsigunguex[0]);
                        if(setsigunguex?.length > 2){
                            if(item?.ordersigungu?.includes(setsigunguex[1]) > 0){
                                arrlists.push(item);
                            }
                        } else {
                            if(item?.ordersigungu?.includes(setsigunguex[0]) > 0){
                                arrlists.push(item);
                            }
                        }
                    } else {
                        //console.log(setsigunguex, item?.ordersigungu, setsigunguex[0]);
                        if(item?.orderdong?.includes(x?.viewernames) > 0){
                            arrlists.push(item);
                        }
                    }
                });
            });
            listSearchArr = arrlists;
        }
        if(pricemin*1 > 0 && pricemax*1 > 0){
            if(pricemin <= pricemax){
                if(sell_type === '매매'){
                    listSearchArr = listSearchArr?.filter(item => item?.orderprice_sell*1 >= pricemin && item?.orderprice_sell*1 <= pricemax);
                } else {
                    listSearchArr = listSearchArr?.filter(item => item?.orderprice_all*1 >= pricemin && item?.orderprice_all*1 <= pricemax);
                }
            }
        }
        if(areamin*1 > 0 && areamax*1 > 0){
            if(areamin <= areamax){
                if(category_1*1 === 3){
                    listSearchArr = listSearchArr?.filter(item => {
                        if(areatype == 1){
                            return item?.orderarea_floor*1 >= (areamin*3.3058) && item?.orderarea_floor*1 <= (areamax*3.3058)
                        }
                        return item?.orderarea_floor*1 >= areamin && item?.orderarea_floor*1 <= areamax
                    });
                } else {
                    listSearchArr = listSearchArr?.filter(item => {
                        if(areatype == 1){
                            return item?.orderarea_private*1 >= (areamin*3.3058) && item?.orderarea_private*1 <= (areamax*3.3058)
                        }
                        return item?.orderarea_private*1 >= areamin && item?.orderarea_private*1 <= areamax
                    });
                }
            }
        }
        if(selectorderby*1 !== 0){
            console.log(selectorderby, statusArrs?.find(item => item?.idx*1 === selectorderby*1));
            listSearchArr = listSearchArr?.filter(item => item?.statusname === statusArrs?.find(item => item?.idx*1 === selectorderby*1)?.title);
        }

        if(polygons?.length > 0 && polystatus === true){
            var polygon_array = new Array();
            polygons[0]?.points?.map((x, i) => {
                polygon_array.push([x?.y, x?.x]);
                //polygon_array[0] = new Array(x?.y, x?.x);
            })

            listSearchArr = listSearchArr?.filter(item => {
                var points_array = new Array();
                points_array[item?.dong] = new Array(item?.lat, item?.lng);
                const { inside } = polygon_point_check(polygon_array, points_array);
                console.log(inside, points_array, polygon_array, polygon_point_check(polygon_array, points_array));
                if(inside === true){
                    return item;
                }
            });
        }
        
        if(seldamdang*1 > 0){
            listSearchArr = listSearchArr?.filter(item => item?.damdangidx*1 === seldamdang*1 );
        }
        
        setproductlistTd(listSearchArr);

        let clustorlist = [];
        listSearchArr?.map((x, i) => {
            if(x['lat']*1 > 0){
                clustorlist.push({idx: x['idx']*1, lat: x['lat']*1, lng: x['lng']*1});    
            }
        });
        //console.log("clustorlistclustorlistclustorlist", clustorlist);
        //setTimeout(() => {
        setpositions(clustorlist);
        // setlatlng({lat: clustorlist[0]?.lat, lng: clustorlist[0]?.lng });
        //}, 2000);
        //sell_type
        setlistloading(false);
        setloadingstep(4);
        dispatch(loadingflas({ loading: false }));
    }
    useEffect(() => {
        setsearchwidth2(MIN_WIDTH);
    }, []);
    const listopen = () => {
        dispatch(loadingflas({ loading: true }));
        let sender = {}
        APIS.postData('/v1/item/list', sender).then(({ data }) => {
            console.log("data !!!!: ", data)
            let datas = data?.list;
            let customers = data?.customers;
            let mediations = data?.mediations;
            console.log(customers);
            setcustomerlist(customers?.filter(item => item?.u_idx === memberinfos?.idx));
            if(datas){

                let tdlist = [];
                let now = moment(new Date());
                //console.log("???????",datas);
                let mediation_stay_counts = 0;
                let mediation_complate_counts = 0;
                datas?.map((x, i) => {
                    let pushData = {};
                    let setcustomers = customers;
                    setcustomers = setcustomers?.filter(item => item?.sell_type === x?.sell_type && item?.category_1*1 === x?.category_1*1 && item?.category_2*1 === x?.category_2*1);
                    setcustomers = setcustomers?.filter(customer => filterItemsProduct(x, customer));
                    if(x?.idx == 22447){
                        console.log("22447:::::",setcustomers?.map((tx) => tx.idx ))
                    }
                    let productCode = String(x?.idx);

                    productlistTh?.map((x2, i2) => {

                        //${((item?.area_supply*1)/3.3057).toFixed(2)
                        if(x2?.sellstatus === true && x2?.key !== '?????'){
                            if(x2?.key === 'productcode'){
                                pushData[x2?.key] = productCode;
                            } else if(x2?.key === 'status'){
                                pushData[x2?.key] = statusName?.find(item => item?.idx*1 === x[x2?.key]*1)?.arrays; //0:명칭, 1: 색상, 2: select 여부 y or no
                                pushData['statusname'] = statusName?.find(item => item?.idx*1 === x[x2?.key]*1)?.title;

                            } else if(x2?.key === 'item_room'){
                                pushData[x2?.key] = x['item_room']+"/"+x['item_bathroom']; //
                            } else if(x2?.key === 'create_dt'){
                                pushData[x2?.key] = moment(x[x2?.key]).format('YY/MM/DD'); //
                            } else if(x2?.key === 'update_dt'){
                                let nowdate = moment().format('YYYY-MM-DD');
                                let updateDates = moment(x[x2?.key]).format('YYYY-MM-DD');
                                let anows = moment(`${nowdate} 00:00:00`);
                                let aupdate_ymd = moment(`${updateDates} 00:00:00`);
                                let aduration = moment.duration(anows.diff(aupdate_ymd));
                                let adays = aduration.asDays();
                                //console.log("daysdaysdays", nowdate);
                                if(parseInt(adays) === 0){
                                    pushData[x2?.key] = '오늘'; //
                                } else {
                                    pushData[x2?.key] = parseInt(adays) + '일 전'; //
                                }
                                pushData['orderupdatedt'] = parseInt(adays);
                            } else if(x2?.key === 'category_2name'){
                                pushData[x2?.key] = configdata?.consts?.category_2_OptionConsts?.find((item) => (item?.idx*1 === x['category_2']*1))?.title;
                            } else if(x2?.key === 'user'){
                                pushData[x2?.key] = x?.user?.name+" "+x?.user?.rank; //
                            } else if(x2?.key === 'price_sell'){
                                if(x['sell_type'] === '매매'){
                                    pushData[x2?.key] = numFormat(x[x2?.key]); //
                                } else if(x['sell_type'] === '월세'){
                                    pushData[x2?.key] = numFormat(x['price_all'])+"/"+numFormat(x['price_month']); //
                                } else {
                                    pushData[x2?.key] = numFormat(x['price_all']); //
                                }
                            } else if(x2?.key === 'matching'){
                                pushData[x2?.key] = `${setcustomers?.length}건`;
                            } else if(x2?.key === 'revenue'){
                                let set1 = x?.now_price_month*12; //현월세 * 12
                                let set2 = (x?.price_sell*1)-(x?.now_price_all*1); //매매가격 - 현보증금
                                let revenueprice = (set1/set2).toFixed(4);
                                pushData[x2?.key] = `${(revenueprice*100).toFixed(2)}%`;
                            } else if(x2?.key === 'realinvest'){
                                let investprice = 0;
                                if(x?.sell_type === '매매'){
                                    investprice = (x?.price_sell*1)-((x?.now_price_all*1)+(x?.price_keymoney*1));
                                } else {
                                    investprice = (x?.price_all*1)+(x?.price_keymoney*1);
                                }
                                pushData[x2?.key] = `${numFormat(investprice)}만원`;
                            } else if(x2?.key === 'pypricetype1'){
                                let set1 = (x?.price_sell*1)/(x?.area_supply*0.3025); //매매가/(공급면적*0.3025)
                                pushData[x2?.key] = `${numFormat(Math.floor(set1))}만원`;
                            } else if(x2?.key === 'pypricetype2'){
                                let set1 = (x?.price_sell*1)/(x?.area_private*0.3025); //매매가/(전용면적*0.3025)
                                pushData[x2?.key] = `${numFormat(Math.floor(set1))}만원`;
                            } else if(x2?.key === 'pypricetype3'){
                                let set1 = (x?.price_sell*1)/(x?.area_land*0.3025); //매매가/(토지면적*0.3025)
                                pushData[x2?.key] = `${numFormat(Math.floor(set1))}만원`;
                            } else if(x2?.key === 'pypricetype4'){
                                let set1 = (x?.price_sell*1)/(x?.area_floor*0.3025); //매매가/(연면적*0.3025)
                                pushData[x2?.key] = `${numFormat(Math.floor(set1))}만원`;
                            } else if(x2?.key === 'pypricetype4'){
                                let set1 = (x?.price_sell*1)/(x?.area_floor*0.3025); //매매가/(연면적*0.3025)
                                pushData[x2?.key] = `${numFormat(Math.floor(set1))}만원`;
                            } else if(x2?.key === 'mediation'){
                                mediation_stay_counts = mediations?.filter(item => item?.i_idx*1 === x?.idx*1 && item?.status*1 === 1 && item?.finstatus*1 === 0)?.length;
                                mediation_complate_counts = mediations?.filter(item => item?.i_idx*1 === x?.idx*1 && item?.status*1 === 2 && item?.finstatus*1 === 0)?.length;
                                pushData[x2?.key] = [mediation_stay_counts*1, mediation_complate_counts*1];
                                pushData['mediations'] = (mediation_stay_counts*1 > 0 || mediation_complate_counts > 0) ? true : null;
                            } else if(x2?.key === 'area_supply' || x2?.key === 'area_contract' || x2?.key === 'area_private' || x2?.key === 'area_land' || x2?.key === 'area_floor'){
                                //${((item?.area_supply*1)/3.3057).toFixed(2)
                                pushData[x2?.key] = ((x[x2?.key]*1)/3.3057).toFixed(2)+"평";
                            } else {
                                pushData[x2?.key] = x[x2?.key];
                            }
                        }
                    });
                    //console.log(pushData);
                    pushData.client_hp = x['client_hp'];
                    pushData.item_usage = x['item_usage'];
                    pushData.desc = x['desc'];

                    pushData['ordercreatedt'] = moment(x['create_dt']).format('YYYYMMDD')*1;
                    pushData['orderprice_sell'] = x['price_sell']*1;
                    pushData['orderprice_all'] = x['price_all']*1;
                    pushData['orderarea_private'] = x['area_private']*1;
                    pushData['orderarea_floor'] = x['area_floor']*1;
                    pushData['category_1'] = x['category_1']*1;
                    pushData['category_2'] = x['category_2']*1;
                    pushData['idx'] = x['idx']*1;
                    pushData['lat'] = x['lat']*1;
                    pushData['lng'] = x['lng']*1;
                    pushData['damdangidx'] = x?.user?.idx;
                    pushData['ordersigungu'] = x['sigungu'];
                    pushData['orderdong'] = x['dong'];
                    pushData['orderjibun'] = x['jibun'];
                    pushData['ordertitle'] = x['title'];
                    pushData['jp_item_send'] = x['jp_item_send'];
                    pushData['mediations1'] = mediation_stay_counts ? mediation_complate_counts : 0;
                    pushData['mediations2'] = mediation_complate_counts ? mediation_complate_counts : 0;
                    tdlist.push(pushData);
                    
                })
                
                setsaveproductlistTd(tdlist);
                setproductlistTd(tdlist);

                setupdatestatus(false);
                setlistDataAll(datas);
                searchlistSet(); 
            }
        }).catch(({ response }) => {
            //const { data } = response;
        }).finally(() => {
            
        });           
    }

    const dragHandler = (e) => {
        const target = e.currentTarget.parentElement;

        leftdivref?.current?.scrollTo({
            left: 0,
            behavior: "smooth",
        });
                
        if (!target) return;
      
        const resize = (e2) => {
            const right = target.getBoundingClientRect().left + target.getBoundingClientRect().width;
            const left = e2.clientX;
            let movefixel = MIN_WIDTH-left;
            //console.log(width, left, MIN_WIDTH, (MIN_WIDTH-movefixel));
            if((MIN_WIDTH-movefixel) < 600){
                setsearchwidth(600);
                setmoverleft(590);
                setsearchwidth2(width-600);
                return;
            } else if ((MIN_WIDTH-movefixel) > (width-100)){
                setsearchwidth(width-100);
                setmoverleft((width-100)-14);
                setsearchwidth2(100);
            } else {
                setsearchwidth(MIN_WIDTH-movefixel);
                setmoverleft((MIN_WIDTH-movefixel)-14);
                setsearchwidth2(MIN_WIDTH+movefixel);
            }
          
        };
      
        document.addEventListener('mousemove', resize);
        document.addEventListener('mouseup', () => document.removeEventListener('mousemove', resize), { once: true });
    }

    const selectOverlay = (type) => {
        const manager = managerRef.current
        console.log(manager);
        manager.cancel()
        manager.select(type)
    }
    const searchClear = () => {
        if(seltypes){
            if(seltypes*1 === 1){
                setsell_type('매매');
            } else {
                setsell_type('전세');
            }
        }
        if(category_1s){
            setcategory_1(category_1s);
        }
        //setcategory_2(configdata?.consts?.category_2_OptionConsts?.find((x, i) => (x?.category_1 === category_1s && i === 0))?.idx);
        setcategory_2(0);
        setlistselecterviewerlist([]);
        setsearchvar('');
        setcheckvalues([]);
        setordercreatedt(0);
        
        setpricemin('');
        setpricemax('');
        setareamin('');
        setareamax('');
    }
    
    useEffect(() => {
        if(loadingstep === 4){
            if(updatestatus === true){
                setloadingstep(3);
            }
        }
    }, [updatestatus]);

    const updateoutside = (sender={}) => {
        // console.log(sender);
        // return;
        if(sender?.status*1 === 1){
            dispatch(loadingflas({ loading: true }));
            APIS.postData('/v1/item/oustsideupdate', sender).then(({ data }) => {
                if(data){
                    //listopen();
                }
            }).catch(({ response }) => {
                const { data } = response;
                console.log(response);
            }).finally(() => {
                dispatch(loadingflas({ loading: false }));
            });     
        } else {
            dispatch(
                open({
                    component: `매물번호 ${sender?.idx} 매물 홍보를 중단합니다. 언제든지 다시 홍보를 진행하실 수 있습니다.`,
                    title: '알림',
                    titleviewer: true,
                    alert: false,
                    button: "확인",
                    onPress: () => {
                        dispatch(loadingflas({ loading: true }));
                        APIS.postData('/v1/item/oustsideupdate', sender).then(({ data }) => {
                            if(data){
                                dispatch(close());
                                //listopen();
                            }
                        }).catch(({ response }) => {
                            const { data } = response;
                        }).finally(() => {
                            dispatch(loadingflas({ loading: false }));
                        });     
                    }
                })
            );   
        }
    }
    const onClusterclick = (_target, cluster) => {

        // 클러스터 고유의 idx 값들
        // setClickClur(cluster?._eventIds);
        console.log(cluster?._markers);
        let push = [];

        let lists = cluster?._markers;
        lists?.map((x, i) => {
            if (x?.a?.children[1]?.id) push.push((x?.a?.children[1]?.id * 1));
        });

        console.log(push);

        if (push?.length > 0) mapFilterClurFunc(push);
        setclurChk(true);
    };


    const mapFilterClurFunc = (list) => {
        console.log('????asdfasdfasf', list);
        // 모든 리스트
        let oriList = saveproductlistTd;


        if (list?.length > 0) {
            console.log(oriList)
            oriList = oriList?.filter(x => list.includes(x?.idx))
        }

        setproductlistTd(oriList);

        
    }
    return(
        <>
        {listsetpopstatus === true && <ListsettingPop setlistsetpopstatus={setlistsetpopstatus} /> }
        {productdetailflag === true && productIdx*1 > 0 && <ProductDetailPop 
            setproductdetailflag={setproductdetailflag} 
            setproductsendflag={setproductsendflag} 
            setproducttogetherflag={setproducttogetherflag}
            productIdx={productIdx}
            settogetherinfoData={settogetherinfoData}
            setSendDatas={setSendDatas}
            
        /> }
        {productsendflag === true && productIdx*1 > 0 && 
            <ProductSendPop productIdx={productIdx} SendDatas={SendDatas} setproductdetailflag={setproductdetailflag} setproductsendflag={setproductsendflag}  /> 
        }
        {producttogetherflag === true && <ProductTogetherPop togetherinfoData={togetherinfoData} setproductdetailflag={setproductdetailflag} setproducttogetherflag={setproducttogetherflag} /> }
        {detailwrite === true && <ProductDetailwrite setdetailwrite={setdetailwrite} uidx={productIdx} setupdatestatus={setupdatestatus} row={row} /> }


        <Layout header={false} actives={'1'} footters={false} setsell_type={setsell_type} setcategory_1={setcategory_1} setcategory_2={setcategory_2} detailFlag={productdetailflag} detailFlag2={listsetpopstatus}>
            <div
                style={{ width: searchwidth, overflowX: 'auto', overflowY: 'hidden'}}
                className='padding40'
                ref={leftdivref}
            >
                <div
                    className='productmobilesecrcharea'
                >
                    <div
                        style={{
                            width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'space-between',
                            gap: 8, position: 'relative'
                        }}
                    >
                        <div style={{ width: 'calc(40% - 40px)'}}>
                            <Select 
                                setValues={setsell_type}
                                values={sell_type}
                                selectData={[
                                    {labels: '매매', values: '매매'},
                                    {labels: '전세', values: '전세'},
                                    {labels: '월세', values: '월세'},
                                ]}
                            />                            
                        </div>
                        <div style={{ width: 'calc(30% - 40px)'}}>
                            <Select 
                                styles={{}}
                                setValues={(e) => {
                                    console.log(e);
                                    setcategory_1(e*1);
                                    //setcategory_2(category_2_setting?.filter((x2, i2) => (x2.category_1*1 === e*1))[0]?.values);
                                    setcategory_2(0);
                                }} 
                                values={category_1}
                                selectData={category_1_setting2}
                            />                               
                        </div>
                        <div style={{ width: '30%'}}>
                            <Select 
                                styles={{}}
                                setValues={(e) => {
                                    setcategory_2(e*1);
                                }} 
                                values={category_2}
                                selectData={category_2_setting2?.filter((x, i) => x?.category_1*1 === category_1*1)}
                            />                            
                        </div>
                        <div style={{ width: 40}}>
                            <Button 
                                titleimgs={`${listsetbuttonactive === true ? './images/icons/equalizer-line-white.svg' : './images/icons/equalizer-line.svg'}`}
                                buttonTxt={''} 
                                className={`listsetbutton ${listsetbuttonactive === true ? 'active' : ''}`} 
                                onPress={() => {
                                    setlistsetbuttonactive(!listsetbuttonactive)
                                }} 
                            />                            
                        </div>
                        <div style={{ width: 40}}>
                            <Button 
                                titleimgs={`${mobilesearchviewflag === true ? './images/icons/chevron-up-white.svg' : './images/icons/chevron-down.svg'}`}
                                buttonTxt={''} 
                                className={`listsetbutton ${mobilesearchviewflag === true ? 'active' : ''}`} 
                                styles={{
                                    backgroundColor: mobilesearchviewflag === true ? '#6164A5' : '#fff'
                                }}
                                onPress={() => {
                                    setmobilesearchviewflag(!mobilesearchviewflag)
                                }} 
                            />                            
                        </div>
                    </div>
                    {mobilesearchviewflag === true &&
                    <div style={{ 
                        position: 'absolute', left: 0, top: 45, width: '100%', zIndex: 999, backgroundColor: '#f9f9fd',
                        padding: 12
                    }} className='margint8'>
                        <div
                            style={{
                                width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 8
                            }}
                        >
                            <div style={{ width: '50%'}}>
                                <Select 
                                    setValues={setordercreatedt}
                                    values={ordercreatedt}
                                    selectData={[
                                        {labels: '접수일 최신순', values: 0},
                                        {labels: '접수일 과거순', values: 1},
                                        {labels: '확인일 최신순', values: 2},
                                        {labels: '확인일 과거순', values: 3},
                                        {labels: '낮은 가격순', values: 4},
                                        {labels: '높은 가격순', values: 5},
                                        {labels: '면적 좁은순', values: 6},
                                        {labels: '면적 넓은순', values: 7},
                                    ]}
                                />
                            </div>
                            {memberinfos?.level*1 === 3 &&
                            <div style={{ width: '50%'}}>
                                <Select 
                                    setValues={setseldamdang}
                                    values={seldamdang}
                                    selectData={( [{labels: '임직원 전체', values: ''}].concat(damdanglist) )}

                                />
                            </div>              
                            }
                        </div>
                        <div className='margint8'>
                            {/* <Checkbox
                                linetype={'radioimg'}
                                values={checkvalues}
                                setvalues={setcheckvalues}
                                namevalue={[
                                    {names: '완료매물 보기', values: 1},
                                ]}
                                fontweights={400}
                                fontSizes={14}
                                sizes={20}
                            /> */}
                            <Checkbox
                                linetype={'radioimg'}
                                values={checkvalues}
                                setvalues={setcheckvalues}
                                namevalue={[
                                    {names: '공동중개 진행 매물만 보기', values: 1},
                                ]}
                                fontweights={400}
                                fontSizes={14}
                                sizes={20}
                            />
                        </div> 
                        <div className='margint8'>
                            <Input 
                                className={`inputs`}
                                placeholder="주소/건물명/매물번호/연락처/용도/비고"
                                setValue={setsearchvar}
                                value={searchvar}
                                name="mb_phone"
                                allwaysclearflag={true}
                                searchicons={true}
                                style={{
                                    paddingLeft: 35
                                }}
                            />                    
                        </div> 
                        <div className="listselecterviewer">
                        <div className='selstickdelarea'>
                            {listselecterviewerlist?.length > 0 && listselecterviewerlist?.map((x, i) => {
                                return (
                                    <button type="button" 
                                        key={i}
                                        onClick={() => {
                                            setlistselecterviewerlist(listselecterviewerlist?.filter(item => item?.viewernames !== x?.viewernames));  
                                        }}                                            
                                    >
                                        {x?.viewernames}
                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                            <path fillRule="evenodd" clipRule="evenodd" d="M3.52851 3.52851C3.78886 3.26816 4.21097 3.26816 4.47132 3.52851L7.99992 7.05711L11.5285 3.52851C11.7889 3.26816 12.211 3.26816 12.4713 3.52851C12.7317 3.78886 12.7317 4.21097 12.4713 4.47132L8.94273 7.99992L12.4713 11.5285C12.7317 11.7889 12.7317 12.211 12.4713 12.4713C12.211 12.7317 11.7889 12.7317 11.5285 12.4713L7.99992 8.94273L4.47132 12.4713C4.21097 12.7317 3.78886 12.7317 3.52851 12.4713C3.26816 12.211 3.26816 11.7889 3.52851 11.5285L7.05711 7.99992L3.52851 4.47132C3.26816 4.21097 3.26816 3.78886 3.52851 3.52851Z" fill="#999999"/>
                                        </svg>                                
                                    </button>
                                );
                            })}
                        </div>
                        <div>
                            <div />
                                <div>
                                    {listselecterviewerlist?.length > 0 ? 
                                    <Button 
                                        titleimgs={'./images/icons/loop-left-line-white.svg'}
                                        buttonTxt={'초기화'} 
                                        className={`selectlistclear`} 
                                        styles={{
                                            color: '#fff', fontSize: 12
                                        }}
                                        onPress={() => {
                                            searchClear();
                                        }} 
                                    />                                   
                                    :
                                    <Button 
                                        titleimgs={'./images/icons/loop-left-line.svg'}
                                        buttonTxt={'초기화'} 
                                        className={`selectlistclear`} 
                                        styles={{
                                            color: '#333', backgroundColor: '#fff'
                                        }}
                                        onPress={() => {
                                            searchClear();
                                        }} 
                                    />                                   
                                    }
                                
                                </div>
                            </div>
                        </div>                        
                    </div>
                    }
                </div>
                <div
                    style={{ width: searchwidth > MIN_WIDTH ? searchwidth-87 : MIN_WIDTH-87 }}
                    className='productsecrcharea'
                >
                    <div className="productsearch padding20">
                        <div className="searchselect">
                            <Button buttonTxt={'매매'} className={`searchbutton ${sell_type === '매매' ? 'active' : ''}`} onPress={() => {
                                setsell_type('매매') 
                            }} />
                            <Button buttonTxt={'전세'} className={`searchbutton ${sell_type === '전세' ? 'active' : ''}`} onPress={() => {
                                setsell_type('전세') 
                            }} />
                            <Button buttonTxt={'월세'} className={`searchbutton ${sell_type === '월세' ? 'active' : ''}`} onPress={() => {
                                setsell_type('월세') 
                            }} />
                        </div>
                        <div className="searchetcselect">
                            <div>
                                <Radios
                                    linetype={'radioimg'}
                                    values={category_1}
                                    setvalues={(e) => {
                                        setcategory_1(e*1);
                                        //setcategory_2(category_2_setting?.filter((x2, i2) => (x2.category_1*1 === e*1))[0]?.values);
                                        setcategory_2(0);
                                    }} 
                                    namevalue={
                                        [{names: '전체', values: 0}].concat(category_1_OptionConsts)
                                    }
                                    fontweights={400}
                                    fontSizes={14}
                                    sizes={20}
                                />
                            </div>
                            <div className='margint12'>
                                {category_1 != 0 &&
                                <Radios
                                    linetype={'checkimg'}
                                    values={category_2}
                                    setvalues={setcategory_2}
                                    namevalue={
                                        [{names: '전체', values: 0}].concat(category_2_setting?.filter((x, i) => x?.category_1*1 === category_1*1))
                                    }
                                    fontweights={400}
                                    fontSizes={14}
                                    sizes={20}
                                />}
                            </div>
                        </div>
                    </div>
                    <div className="listselecter">
                        <div>
                            <div>
                                <Select 
                                    setValues={setordercreatedt}
                                    values={ordercreatedt}
                                    selectData={[
                                        {labels: '접수일 최신순', values: 0},
                                        {labels: '접수일 과거순', values: 1},
                                        {labels: '확인일 최신순', values: 2},
                                        {labels: '확인일 과거순', values: 3},
                                        {labels: '낮은 가격순', values: 4},
                                        {labels: '높은 가격순', values: 5},
                                        {labels: '면적 좁은순', values: 6},
                                        {labels: '면적 넓은순', values: 7},
                                    ]}
                                />
                            </div>
                            {memberinfos?.level*1 === 3 &&
                            <div>
                                <Select 
                                    setValues={setseldamdang}
                                    values={seldamdang}
                                    selectData={( [{labels: '임직원 전체', values: ''}].concat(damdanglist) )}

                                />
                            </div>              
                            }
                            <div>
                                {/* <Checkbox
                                    linetype={'radioimg'}
                                    values={checkvalues}
                                    setvalues={setcheckvalues}
                                    namevalue={[
                                        {names: '완료매물 보기', values: 1},
                                    ]}
                                    fontweights={400}
                                    fontSizes={14}
                                    sizes={20}
                                /> */}
                                <Checkbox
                                    linetype={'radioimg'}
                                    values={checkvalues}
                                    setvalues={setcheckvalues}
                                    namevalue={[
                                        {names: '공동중개 진행 매물만 보기', values: 1},
                                    ]}
                                    fontweights={400}
                                    fontSizes={14}
                                    sizes={20}
                                />
                            </div>  
                        </div>
                        <div>
                            <div>
                                <Input 
                                    className={`inputs`}
                                    placeholder="주소/건물명/매물번호/연락처/용도/비고"
                                    setValue={setsearchvar}
                                    value={searchvar}
                                    name="mb_phone"
                                    allwaysclearflag={true}
                                    searchicons={true}
                                    style={{
                                        paddingLeft: 35
                                    }}
                                />                    
                            </div>            
                            <div style={{ position: 'relative'}}>
                                <Button 
                                    titleimgs={`${listsetbuttonactive === true ? './images/icons/equalizer-line-white.svg' : './images/icons/equalizer-line.svg'}`}
                                    buttonTxt={''} 
                                    className={`listsetbutton ${listsetbuttonactive === true ? 'active' : ''}`} 
                                    onPress={() => {
                                        setlistsetbuttonactive(!listsetbuttonactive)
                                    }} 
                                />
                                
                            </div>    
                        </div>
                    </div>
                    <div className="listselecterviewer">
                        <div className='selstickdelarea'>
                            {listselecterviewerlist?.length > 0 && listselecterviewerlist?.map((x, i) => {
                                return (
                                    <button type="button" 
                                        key={i}
                                        onClick={() => {
                                            setlistselecterviewerlist(listselecterviewerlist?.filter(item => item?.viewernames !== x?.viewernames));  
                                        }}                                            
                                    >
                                        {x?.viewernames}
                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                            <path fillRule="evenodd" clipRule="evenodd" d="M3.52851 3.52851C3.78886 3.26816 4.21097 3.26816 4.47132 3.52851L7.99992 7.05711L11.5285 3.52851C11.7889 3.26816 12.211 3.26816 12.4713 3.52851C12.7317 3.78886 12.7317 4.21097 12.4713 4.47132L8.94273 7.99992L12.4713 11.5285C12.7317 11.7889 12.7317 12.211 12.4713 12.4713C12.211 12.7317 11.7889 12.7317 11.5285 12.4713L7.99992 8.94273L4.47132 12.4713C4.21097 12.7317 3.78886 12.7317 3.52851 12.4713C3.26816 12.211 3.26816 11.7889 3.52851 11.5285L7.05711 7.99992L3.52851 4.47132C3.26816 4.21097 3.26816 3.78886 3.52851 3.52851Z" fill="#999999"/>
                                        </svg>                                
                                    </button>
                                );
                            })}
                        </div>
                        <div>
                            <div />
                            <div>
                                {listselecterviewerlist?.length > 0 ? 
                                <Button 
                                    titleimgs={'./images/icons/loop-left-line-white.svg'}
                                    buttonTxt={'초기화'} 
                                    className={`selectlistclear`} 
                                    styles={{
                                        color: '#fff', fontSize: 12
                                    }}
                                    onPress={() => {
                                        searchClear();
                                    }} 
                                />                                   
                                :
                                <Button 
                                    titleimgs={'./images/icons/loop-left-line.svg'}
                                    buttonTxt={'초기화'} 
                                    className={`selectlistclear`} 
                                    styles={{
                                        color: '#333', backgroundColor: '#fff'
                                    }}
                                    onPress={() => {
                                        searchClear();
                                    }} 
                                />                                   
                                }
                             
                            </div>
                        </div>
                    </div>
                </div>
                <div
                    className='product_scroll_list_div'
                    style={{ height: 'calc(100% - 246px)', width: searchwidth > MIN_WIDTH ? searchwidth-87 : MIN_WIDTH-87 }}
                >
                    <table 
                        style={{ width: searchwidth > MIN_WIDTH ? searchwidth-97 : MIN_WIDTH-97, }}
                        className='tablelistarea'
                    >
                        <thead 
                            style={{
                                backgroundColor: '#F2F4F7',
                                textAlign: "center",
                                position: "sticky",
                                top: "0",
                                border: '1px solid red',
                                zIndex: 1
                            }}                        
                        >
                            <tr>
                                {productlistTh?.map((x, i) => {
                                    //console.log(x);
                                    if(x?.key === 'status'){
                                        return (
                                        <>
                                        <th 
                                            key={i}
                                        >
                                            <div
                                                style={{
                                                    display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 10
                                                }}
                                            >
                                                <button
                                                    onClick={() => {
                                                        setlistsetpopstatus(true);
                                                    }}
                                                >
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                                                        <path d="M1.84441 11.7167C1.60022 10.5628 1.61011 9.39517 1.84511 8.28357C2.77004 8.3925 3.57737 8.08617 3.84136 7.44884C4.10534 6.81152 3.75107 6.02405 3.02004 5.44704C3.6399 4.49484 4.45857 3.66218 5.44709 3.01899C6.02415 3.75041 6.81185 4.10493 7.44933 3.84087C8.08682 3.57681 8.39308 2.76915 8.28397 1.84393C9.43775 1.59973 10.6054 1.60962 11.7171 1.84462C11.6082 2.76955 11.9144 3.57688 12.5517 3.84087C13.1891 4.10486 13.9766 3.75059 14.5536 3.01955C15.5057 3.63941 16.3384 4.45809 16.9816 5.4466C16.2502 6.02366 15.8957 6.81136 16.1597 7.44884C16.4238 8.08633 17.2315 8.39267 18.1567 8.28348C18.4009 9.43725 18.391 10.6049 18.156 11.7166C17.2311 11.6077 16.4237 11.914 16.1597 12.5513C15.8958 13.1886 16.25 13.9761 16.9811 14.5531C16.3612 15.5053 15.5425 16.3379 14.554 16.9812C13.977 16.2498 13.1892 15.8952 12.5517 16.1593C11.9142 16.4233 11.608 17.231 11.7172 18.1562C10.5633 18.4004 9.39567 18.3905 8.28406 18.1555C8.393 17.2306 8.08666 16.4233 7.44933 16.1593C6.81201 15.8953 6.02454 16.2495 5.44752 16.9806C4.49532 16.3608 3.66267 15.5421 3.01948 14.5535C3.7509 13.9765 4.10541 13.1888 3.84136 12.5513C3.5773 11.9138 2.76963 11.6075 1.84441 11.7167ZM3.33394 10.1753C4.25045 10.4289 5.00679 11.0097 5.38116 11.9135C5.75552 12.8173 5.63137 13.7628 5.16266 14.5902C5.24312 14.6749 5.3258 14.7576 5.41058 14.8379C6.23798 14.3693 7.18342 14.2452 8.08713 14.6195C8.99083 14.9938 9.57158 15.7501 9.82533 16.6665C9.94208 16.6697 10.0589 16.6698 10.1757 16.6667C10.4294 15.7502 11.0102 14.9938 11.914 14.6195C12.8177 14.2451 13.7632 14.3693 14.5907 14.838C14.6754 14.7575 14.758 14.6748 14.8383 14.59C14.3697 13.7627 14.2456 12.8172 14.6199 11.9135C14.9942 11.0098 15.7506 10.429 16.667 10.1753C16.6702 10.0586 16.6702 9.94167 16.6672 9.82483C15.7507 9.57125 14.9943 8.99042 14.6199 8.08664C14.2456 7.18286 14.3698 6.23737 14.8384 5.40995C14.758 5.32518 14.6753 5.24259 14.5905 5.16224C13.7632 5.63089 12.8177 5.755 11.914 5.38067C11.0102 5.00634 10.4295 4.25005 10.1758 3.33362C10.0591 3.33047 9.94217 3.33041 9.82533 3.33345C9.57167 4.24996 8.99092 5.00631 8.08713 5.38067C7.18335 5.75503 6.23786 5.63088 5.41043 5.16217C5.32566 5.24264 5.24307 5.32531 5.16273 5.4101C5.63138 6.23749 5.75549 7.18293 5.38116 8.08664C5.00682 8.99033 4.25054 9.57117 3.3341 9.82483C3.33096 9.94158 3.3309 10.0584 3.33394 10.1753ZM10.0006 12.5001C8.61983 12.5001 7.50055 11.3808 7.50055 10.0001C7.50055 8.61934 8.61983 7.50007 10.0006 7.50007C11.3812 7.50007 12.5006 8.61934 12.5006 10.0001C12.5006 11.3808 11.3812 12.5001 10.0006 12.5001ZM10.0006 10.8334C10.4607 10.8334 10.8339 10.4603 10.8339 10.0001C10.8339 9.53984 10.4607 9.16675 10.0006 9.16675C9.54033 9.16675 9.16725 9.53984 9.16725 10.0001C9.16725 10.4603 9.54033 10.8334 10.0006 10.8334Z" fill="#999999"/>
                                                    </svg>                                            
                                                </button>
                                                <div style={{ width: 1, height: 12, backgroundColor: '#CCC'}} />
                                                <div style={{ width: 50 }}>
                                                <Select 
                                                    backgroundColors={'#F2F4F7'}
                                                    selectClass={'simpleselect'}
                                                    setValues={setselectorderby}
                                                    values={selectorderby}
                                                    selectData={( [{labels: '전체', values: ''}].concat(statusArrs) )}
                                                />                                              
                                                </div>
                                            </div>
                                        </th>
                                        <th 
                                            key={'sub'+i}
                                        >
                                           외부공개
                                        </th>
                                        </>
                                        );
                                    } else {
                                        return (
                                            <th key={i}>
                                                {x?.viewernames}
                                            </th>
                                        );
                                    }

                                })}
                                
                            </tr>
                        </thead>
                        {listloading === true ? 
                        <tbody className=''>
                            <tr>
                                <td colspan={30}>
                                    <div style={{
                                        width: '100%', height: 200, 
                                        display: 'flex', alignItems: 'center', justifyContent: 'center',
                                        // backgroundColor: 'rgba(0,0,0,0.5)'
                                    }}>
                                        <img src={`${consts?.s3url}/${configdata?.loading_img}`} width={80} />
                                    </div>
                                </td>
                            </tr>
                        </tbody>

                        :
                        <tbody className=''>
                            {productlistTd?.map((x, i) => {
                                //console.log(x);
                                // listSearchArr = listSearchArr?.filter(item => (
                                //     item?.productcode?.includes(searchvar) ||
                                //     item?.ordertitle?.includes(searchvar) ||
                                //     item?.ordersigungu?.includes(searchvar) ||
                                //     item?.orderdong?.includes(searchvar) ||
                                //     item?.orderjibun?.includes(searchvar) ||
                                //     item?.client_hp?.includes(searchvar) ||
                                //     item?.desc?.includes(searchvar) ||
                                //     item?.item_usage?.includes(searchvar)
                                // ));

                                let listClass = "";
                                if(x['status'][0] === '간편'){
                                    listClass = 'colorF00';
                                }
                                return (
                                    <tr>
                                    {productlistTh?.map((x2, i2) => {
                                        // if(x2?.key === 'productcode'){
                                        //     x[x2.key] = x[x2.key]?.replaceAll(searchvar, `<b>${searchvar}</b>`);
                                        // }
                                        if(x2?.key === 'status'){
                                            return (
                                                <>
                                                <td>
                                                    <div className={`setstyles ${x[x2.key][1]}`}>
                                                        {x[x2.key][2] === 'y' ? 
                                                            <Select 
                                                                selectClass={'simpleselect'}
                                                                setValues={(e) => {
                                                                    //console.log(productlistTd);
                                                                    if(e*1 === 98){
                                                                        return;
                                                                    }
                                                                    let setDatas = statusArrs?.find(item => item?.idx*1 === e*1);
                                                                    //console.log(setDatas);
                                                                    setproductlistTd(productlistTd?.map(item => item?.idx*1 === x?.idx ? { ...item, statusname: setDatas?.title, status: setDatas?.arrays} : item ));
                                                                    setsaveproductlistTd(saveproductlistTd?.map(item => item?.idx*1 === x?.idx ? { ...item, statusname: setDatas?.title, status: setDatas?.arrays} : item ));
                                                                    let sender = {
                                                                        idx: x?.idx,
                                                                        status: e,
                                                                    }
                                                                    dispatch(loadingflas({ loading: true }));
                                                                    APIS.postData('/v1/item/statusUpdate', sender).then(({ data }) => {
                                                                        if(data){
                                                                        }
                                                                    }).catch(({ response }) => {
                                                                        const { data } = response;
                                                                        console.log(response);
                                                                    }).finally(() => {
                                                                        dispatch(loadingflas({ loading: false }));
                                                                    });     
                                                                }}
                                                                values={x[x2.key][3]*1}
                                                                selectData={statusArrs?.filter(item => item?.values*1 !== 98)}
                                                            />                                                    
                                                        :
                                                            x[x2.key][0]
                                                        }
                                                    </div>                                                
                                                </td>
                                                <td >
                                                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }} className={`setstyles`}>
                                                    <button
                                                        type="button"
                                                        onClick={() => {
                                                            let sender = {
                                                                idx: x?.idx,
                                                                status: x?.jp_item_send*1 === 1 ? 0 : 1,
                                                            }
                                                            updateoutside(sender);
                                                            setproductlistTd(productlistTd?.map((item2, index2) => {
                                                                if(item2?.idx === x?.idx){
                                                                    item2.jp_item_send = x?.jp_item_send*1 === 1 ? 0 : 1;
                                                                    return item2;
                                                                } else {
                                                                    return item2;
                                                                }
                                                            }));
                                                        }}
                                                        style={{
                                                            backgroundColor: x?.jp_item_send*1 === 1 ? '#6164A5' : '#5C5C5C', borderRadius: 100, 
                                                            width: 35, padding: 3,
                                                            display: 'flex', alignItems: 'center', justifyContent: x?.jp_item_send*1 === 1 ? 'flex-end' : 'flex-start'
                                                        }}
                                                    >
                                                        <span style={{ borderRadius: '100%', width: 12, height: 12, display: 'flex', backgroundColor: '#fff'}} />
                                                    </button>
                                                    </div>
                                                </td>
                                                </>
                                            );
                                        } else {
                                            if(x2?.key === 'desc'){
                                                return (
                                                    <td
                                                        className={`${listClass}`}
                                                        style={{ cursor: 'pointer' }}
                                                        onDoubleClick={() => {
                                                            if(listDataAll?.find(item => item?.idx*1 === x?.idx*1)?.status === 98){
                                                                setrow(listDataAll?.find(item => item?.idx*1 === x?.idx*1));
                                                                setproductIdx(x?.idx);
                                                                setpopflag(true);
                                                                //setdetailwrite(true);
                                                            } else {
                                                                
                                                                setproductIdx(x?.idx);
                                                                setproductdetailflag(true);
                                                            }
                                                        }}
                                                        onClick={() => {
                                                            //setproductdetailflag(true);
                                                            //console.log('?????????');
                                                            setlatlng({lat: x?.lat, lng: x?.lng });
                                                            
                                                        }}                                                
                                                    >
                                                        <div
                                                            className='textcut_doubleline'
                                                        >
                                                            {x[x2.key]}
                                                        </div>
                                                    </td>
                                                );
                                            } else if(x2?.key === 'mediation'){
                                                return (
                                                    <td
                                                        className={`${listClass}`}
                                                        style={{ cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 5, flexDirection: 'column' }}
                                                        onDoubleClick={() => {
                                                            if(listDataAll?.find(item => item?.idx*1 === x?.idx*1)?.status === 98){
                                                                // console.log(listDataAll[i]);
                                                                setrow(listDataAll?.find(item => item?.idx*1 === x?.idx*1));
                                                                setproductIdx(x?.idx);
                                                                setpopflag(true);
                                                                //setdetailwrite(true);
                                                            } else {
                                                                setproductIdx(x?.idx);
                                                                setproductdetailflag(true);
                                                            }
                                                        }}
                                                        onClick={() => {
                                                            //setproductdetailflag(true);
                                                            //console.log('?????????');
                                                            setlatlng({lat: x?.lat, lng: x?.lng });
                                                            
                                                        }}                                                
                                                    >
                                                        <p className={'stayviewer'+ (x[x2?.key][0] === 0 ? " grey":"")}>대기 {x[x2?.key][0]}</p>
                                                        <p className={'stayviewer complate'+(x[x2?.key][1] === 0 ? " grey":"")}>진행 {x[x2?.key][1]}</p>
                                                    </td>
                                                );
                                            } else {
                                                return (
                                                    <td
                                                        className={`${listClass}`}
                                                        style={{ cursor: 'pointer' }}
                                                        onDoubleClick={() => {
                                                            if(listDataAll?.find(item => item?.idx*1 === x?.idx*1)?.status === 98){
                                                                //console.log(listDataAll[i]);
                                                                console.log("setrow",listDataAll?.find(item => item?.idx*1 === x?.idx*1))
                                                                setrow(listDataAll?.find(item => item?.idx*1 === x?.idx*1));
                                                                setproductIdx(x?.idx);
                                                                setpopflag(true);
                                                                //setdetailwrite(true);
                                                            } else {
                                                                setproductIdx(x?.idx);
                                                                setproductdetailflag(true);
                                                            }
                                                        }}
                                                        onClick={() => {
                                                            //setproductdetailflag(true);
                                                            //console.log('?????????');
                                                            setlatlng({lat: x?.lat, lng: x?.lng });
                                                            
                                                        }}                                                
                                                    >{x[x2.key]}</td>
                                                );
                                            }

                                        }
                                    })}
                                    </tr>
                                );
                            })}
                        </tbody>
                        }
                    </table>
                    {productlistTd?.length === 0 && listloading === false &&
                        <div className='nolistArea'>
                            등록된 매물이 없습니다.
                        </div>                        
                    }
                    <div ref={target} style={{ width: '100%', height: 1 }} />
                </div>
            </div>
            <div
                className={mapViewerflag === true && `mobileViews`}
                style={{ 
                    width: searchwidth2, display: 'flex', alignItems: 'center', justifyContent: 'center', position: 'relative',
                    backgroundImage: 'url(./images/samplemap.png)', backgroundPosition: 'center', backgroundSize: 'cover'
                }}
            >
                <Map // 지도를 표시할 Container
                    id="map"
                    center={latlng}
                    style={{
                        // 지도의 크기
                        width: "100%",
                        height: "100%",
                    }}
                    onCenterChanged={(map) => {
                        const latlng = map.getCenter();
                        setlatlng({lat: latlng.getLat(), lng: latlng.getLng() });
                    }}
                    level={3} // 지도의 확대 레벨
                    ref={mapRef}
                >                
                    <DrawingManager
                        ref={managerRef}
                        drawingMode={[
                            "polygon",
                        ]}
                        onDrawend={(e) => {
                            //console.log('???', e.getData());
                            setpolygons(e.getData()?.polygon);
                        }}
                        onStateChanged={(e) => {
                            setpolygons(e.getData()?.polygon);
                            //console.log('???', e.getData());
                        }}
                        onRemove={(e) => {
                            //console.log('???', e.getData());
                            setpolystatus(false);
                            const manager = managerRef.current
                            manager.cancel();
                        }}
                        
                        guideTooltip={["draw", "drag", "edit"]}
                        polygonOptions={{
                            draggable: true,
                            removable: true,
                            editable: true,
                            strokeColor: "#39f",
                            fillColor: "#39f",
                            fillOpacity: 0.5,
                            hintStrokeStyle: "dash",
                            hintStrokeOpacity: 0.5,
                        }}
                        arrowOptions={{
                            draggable: true, // 그린 후 드래그가 가능하도록 설정합니다
                            removable: true, // 그린 후 삭제 할 수 있도록 x 버튼이 표시됩니다
                            editable: true, // 그린 후 수정할 수 있도록 설정합니다
                            strokeColor: "#39f", // 선 색
                            hintStrokeStyle: "dash", // 그리중 마우스를 따라다니는 보조선의 선 스타일
                            hintStrokeOpacity: 0.5, // 그리중 마우스를 따라다니는 보조선의 투명도
                        }}
                        ellipseOptions={{
                            draggable: true,
                            removable: true,
                            editable: true,
                            strokeColor: "#39f",
                            fillColor: "#39f",
                            fillOpacity: 0.5,
                        }}
                    />        
                    {positions?.length > 0 &&
                    <MarkerClusterer
                        averageCenter={true} // 클러스터에 포함된 마커들의 평균 위치를 클러스터 마커 위치로 설정
                        minLevel={1} // 클러스터 할 최소 지도 레벨
                        disableClickZoom={true}
                        styles={[
                            { // calculator 각 사이 값 마다 적용될 스타일을 지정한다
                                width : '36px', height : '36px',
                                background: '#6164A5',
                                borderRadius: '12px',
                                border: '3px solid #fff',
                                color: '#fff',
                                textAlign: 'center',
                                fontWeight: 'bold',
                                lineHeight: '30px'
                            },
                            {
                                width : '64px', height : '64px',
                                background: 'rgba(255, 255, 255, 1)',
                                borderRadius: '20px',
                                border: '4px solid #6164A5',
                                color: '#6164A5',
                                textAlign: 'center',
                                fontWeight: 'bold',
                                lineHeight: '56px'
                            },
                            {
                                width : '64px', height : '64px',
                                background: 'rgba(255, 255, 255, 1)',
                                borderRadius: '20px',
                                border: '4px solid #6164A5',
                                color: '#6164A5',
                                textAlign: 'center',
                                fontWeight: 'bold',
                                lineHeight: '56px'
                            },
                            {
                                width : '64px', height : '64px',
                                background: 'rgba(255, 255, 255, 1)',
                                borderRadius: '20px',
                                border: '4px solid #6164A5',
                                color: '#6164A5',
                                textAlign: 'center',
                                fontWeight: 'bold',
                                lineHeight: '56px'
                            }
                        ]}
                        onClusterclick={onClusterclick}
                        ref={clusterer}
                    >
                        {positions?.length > 0 && positions?.map((pos) => (
                            <CustomOverlayMap
                                key={`${pos.lat}-${pos.lng}`}
                                position={{
                                    lat: pos.lat,
                                    lng: pos.lng,
                                }}
                            >
                                <div 
                                    style={{
                                        cursor: 'pointer'
                                    }}
                                    onClick={() => {
                                        setproductIdx(pos?.idx);
                                        setproductdetailflag(true);                                        
                                    }}
                                    id={pos?.idx}
                                >
                                    <img src="./images/icons/map-marker-svgrepo-com.svg" width='24' />              
                                </div>
                            </CustomOverlayMap>  
                        ))}
                    </MarkerClusterer>
                    }
                </Map>
                <div className={`polyareas ${polystatus === true ? 'darkbg' : ''}`}  >
                    {polystatus === true ? 
                    <div className='polycancleviewer'>
                        매물 검색을 원하는 영역을 마우스로 그려주세요.
                        <Button
                            onPress={() => {
                                setpolystatus(false);
                                const manager = managerRef.current
                                manager.cancel();
                            }}              
                            className={`polycanclebutton`}       
                            buttonTxt={'취소'}
                        />
                    </div>
                    :
                    <Button
                        onPress={() => {
                            setpolystatus(true);
                            selectOverlay(kakao.maps.drawing.OverlayType.POLYGON)
                        }}              
                        className={`polyaddbutton`}       
                        buttonTxt={'매물 영역 그리기'}
                    />
                    }
                </div>
            </div>
        </Layout>
        <div style={{ left: moverleft }} className={`resizeArea scrollline`} onMouseDown={dragHandler}>
            <div>
                <svg width="58" height="58" xmlns="http://www.w3.org/2000/svg" >
                    <defs>
                        <filter colorInterpolationFilters="sRGB" filterUnits="userSpaceOnUse" height="57" id="filter0_d_5550_3834" width="57" x="0.5" y="0.5">
                            <feFlood floodOpacity="0" result="BackgroundImageFix"/>
                            <feColorMatrix in="SourceAlpha" result="hardAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"/>
                            <feOffset dx="4" dy="4"/>
                            <feGaussianBlur stdDeviation="7.5"/>
                            <feComposite in2="hardAlpha" operator="out"/>
                            <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
                            <feBlend in2="BackgroundImageFix"/>
                            <feBlend in="SourceGraphic" in2="effect1_dropShadow_5550_3834"/>
                        </filter>
                    </defs>
                    <g className="layer">
                        <title>Layer 1</title>
                        <g id="material-symbols-light:arrow-drop-down-circle-rounded">
                            <g filter="url(#filter0_d_5550_3834)" id="Vector">
                                <ellipse cx="26.25" cy="25.17" fill="#ffffff" id="svg_3" rx="13.17" ry="13.17" stroke="#CCCCCC"/>
                            </g>
                            <path d="m33.43,25.77c0.13,-0.12 0.19,-0.27 0.19,-0.44c0,-0.16 -0.06,-0.31 -0.19,-0.44l-3.15,-3.14c-0.18,-0.19 -0.4,-0.23 -0.65,-0.13c-0.26,0.09 -0.38,0.28 -0.38,0.55l0,6.34c0,0.26 0.12,0.44 0.38,0.54c0.25,0.09 0.47,0.05 0.65,-0.14l3.15,-3.14z" fill="#999999" id="Vector_2"/>
                            <path d="m18.94,25.77c-0.13,-0.12 -0.19,-0.27 -0.19,-0.44c0,-0.16 0.06,-0.31 0.19,-0.44l3.14,-3.14c0.19,-0.19 0.41,-0.23 0.66,-0.13c0.25,0.09 0.38,0.28 0.38,0.55l0,6.34c0,0.26 -0.13,0.44 -0.38,0.54c-0.25,0.09 -0.47,0.05 -0.66,-0.14l-3.14,-3.14z" fill="#999999" id="Vector_3"/>
                        </g>
                    </g>
                </svg>                
            </div>

        </div>

        {popflag === true &&
        <div className='PopupArea'>
            <div>
                <div className='PopupAreaBG' 
                    //onClick={() => { setpopflag(false); }}
                />
                <div className='PopupAreaContents'>
                    <div>
                        <div className="popTitle padding20">
                            <span >알림</span>
                            <button
                                onClick={() => {
                                    setpopflag(false);
                                }}
                            >
                                <img src="./images/icons/x.svg" width='20' />                                            
                            </button>
                        </div>
                        <div className="padding32">
                            <div className='popcontents'>
                                <div style={{ width: '100%' }}>
                                    <div>
                                    간편 접수를 통해 등록한 매물은 <span style={{ fontWeight: 700, color: '#6164A5'}}>상세보기 및 AI 매칭</span> 기능이 제공되지 않으므로 매물 수정을 통해 필수 항목을 입력하시기 바랍니다.
                                    </div>
                                </div>
                            </div>
                            
                            <div className='popbuttons'>
                                <div>
                                    <Button
                                        disabled={true}
                                        buttonTxt={'닫기'}
                                        onPress={() => { setpopflag(false); }}
                                    />                                    
                                </div>
                                <div>
                                    <Button
                                        disabled={true}
                                        buttonTxt={'매물삭제'}
                                        onPress={() => { 
                                            setpopflag(false); 
                                            const PopComponents3 = () => {
                                                return (
                                                    <div style={{ textAlign: 'center' }}>
                                                        매물을 휴지통으로 이동합니다.<br />
                                                        휴지통으로 이동 된 정보는 30일 후<br />
                                                        완전히 삭제됩니다.
                                                    </div>
                                                );
                                            }                                                
                                            dispatch(
                                                open({
                                                    component: <PopComponents3 />,
                                                    title: '매물 삭제',
                                                    button: "취소",
                                                    buttonCencle: "삭제하기",     
                                                    titleviewer: true,          
                                                    alert: false,
                                                    onPress: () => {
                                                        dispatch(close());
                                                    },
                                                    onCancelPress: () => {
                                                        let sender = {
                                                            idx: productIdx,
                                                        }
                                                        dispatch(loadingflas({ loading: true }));
                                                        APIS.postData('/v1/item/remove', sender).then(({ data }) => {
                                                            if(data){
                                                                //console.log(data);
                                                                dispatch(close());
                                                                setproductdetailflag(false);
                                                                dispatch(listupdater({ listupdate: true }));
                                                                dispatch(
                                                                    open({
                                                                        component: `매물이 삭제되었습니다.`,
                                                                        title: '알림',
                                                                        titleviewer: true,
                                                                        alert: false,
                                                                        button: "확인",
                                                                        onPress: () => {
                                                                            dispatch(close());
                                                                        }
                                                                    })
                                                                );   
                                                            }
                                                        }).catch(({ response }) => {
                                                            const { data } = response;
                                                            console.log(response);
                                                        }).finally(() => {
                                                            dispatch(loadingflas({ loading: false }));
                                                        });       
                                                    },
                                                })
                                            );                                              
                                        }}
                                    />                                    
                                </div>
                                <div>
                                    <Button
                                        buttonTxt={'매물수정'}
                                        onPress={() => { setpopflag(false); setdetailwrite(true); }}
                                    />                                    
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>
        }
        <div
            className='mobileViewer'
            style={{ 
                position: 'fixed', left: 0, bottom: 10, zIndex: 999,
                width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center'
            }}
        >
            <div>
                <Button
                    buttonTxt={mapViewerflag === true ? '목록보기' : '지도보기'}
                    className={'linenormalbutton'}
                    styles={{
                        backgroundColor: '#fff', width: 160, borderRadius: 100
                    }}
                    onPress={() => { 
                        setmapViewerflag(!mapViewerflag);
                    }}

                />                                    
            </div>
        </div>
        {listsetbuttonactive === true &&
        <div
            style={{
                position: 'absolute', left: 0, top: 0, width: '100%', height: '100%', 
                backgroundColor: 'rgba(0,0,0,0.3)', zIndex: 1000, 
                display: 'flex', alignItems: 'center', justifyContent: 'center'
            }}
        >
            <div className="filterpoparea padding32"
                style={{
                    position: 'relative'
                }}
            >
                <button
                    style={{ position: 'absolute', right: 10, top: 10}}
                    onClick={() => {
                        setlistsetbuttonactive(false);
                    }}
                >
                    <img src="../images/icons/x.svg" width='20' />
                </button>
                <div className="filterSelarea">
                    <div className='filterselect'>
                        {customerlist?.length > 0 &&
                        <Select 
                            setValues={(e) => {
                                if(e !== ''){
                                    
                                    let findCustomerinfos = customerlist?.find(item => item?.idx*1 === e*1);
                                    console.log(findCustomerinfos);
                                    setsell_type(findCustomerinfos?.sell_type);
                                    setcategory_1(findCustomerinfos?.category_1);
                                    setcategory_2(findCustomerinfos?.category_2);
                                    setpricemin(findCustomerinfos?.price_all_min);
                                    setpricemax(findCustomerinfos?.price_all_max);
                                    setareamin(findCustomerinfos?.item_area_min);
                                    setareamax(findCustomerinfos?.item_area_max);
                                    let citys = findCustomerinfos?.citys;
                                    let arrs = [];
                                    citys?.map((x, i) => {
                                        if(x?.dong === '전체'){
                                            arrs.push({viewernames: x?.sigungu+" 전체", sido: x?.sido, sigungu: x?.sigungu});
                                        } else {
                                            arrs.push({viewernames: x?.dong, sido: x?.sido, sigungu: x?.sigungu});
                                        }
                                    });
                                    setlistselecterviewerlist(arrs);
                                    
                                }
                                setcustomerselect(e);
                            }}
                            values={customerselect*1}
                            selectData={( [{labels: '고객 조건으로 선택', values: ''}].concat(customerlist?.map((x, i) => {
                                x.labels = x?.title;
                                x.values = x?.idx*1;
                                return x;
                            })) )}

                        />}
                        <p style={{ fontSize: 11 }}>
                        (지도로 선택 고객은 필터링 되지 않습니다.)
                        </p>
                        {/* customerlist */}
                    </div>
                    <div className='filterSelarealists ' style={{ marginTop: 10 }}>
                        <div className='filterSelarealists1'>
                            <div className='titleTxt'>거래형태</div>
                            {/* <div>매매와 임대는 동시에 선택할 수 없습니다.</div> */}
                            <div>
                                <Radios
                                    linetype={'checkimg'}
                                    flexrows={'column'}
                                    values={sell_type}
                                    setvalues={setsell_type}
                                    namevalue={[
                                        {names: '매매', values: '매매'},
                                        {names: '전세', values: '전세'},
                                        {names: '월세', values: '월세'},
                                    ]}
                                    fontweights={400}
                                    fontSizes={14}
                                    sizes={16}
                                />                                                
                            </div>
                        </div>
                        <div className='filterSelarealists2'>
                            <div className='titleTxt'>매물 종류</div>
                            <div>
                                <Radios
                                    linetype={'radioimg'}
                                    values={category_1}
                                    setvalues={(e) => {
                                        setcategory_1(e*1);
                                        setcategory_2(category_2_setting?.filter((x2, i2) => (x2.category_1*1 === e*1))[0]?.values);
                                    }} 
                                    namevalue={category_1_OptionConsts}
                                    fontweights={400}
                                    fontSizes={14}
                                    sizes={16}
                                />                                                
                            </div>
                            <div>
                                <Radios
                                    linetype={'checkimg'}
                                    flexrows={'column'}
                                    values={category_2}
                                    setvalues={setcategory_2}
                                    namevalue={category_2_setting?.filter((x, i) => x?.category_1*1 === category_1*1)}
                                    fontweights={400}
                                    fontSizes={14}
                                    sizes={16}
                                />                                                
                            </div>
                        </div>
                        <div className='filterSelarealists3'>
                            <div>
                                <div className='titleTxt'>{sell_type === '매매' ? '매매가' : '보증금'}</div>
                                <div>
                                    <div>
                                        <Input 
                                            valid={'num'}
                                            className={`inputs`}
                                            rightplaceholder="만원"
                                            setValue={setpricemin}
                                            value={pricemin}
                                            name="mb_phone"
                                            style={{
                                                paddingRight: 40, textAlign: 'right'
                                            }}
                                        />                                                           
                                    </div>
                                    <div>~</div>
                                    <div>
                                        <Input 
                                            valid={'num'}
                                            className={`inputs`}
                                            rightplaceholder="만원"
                                            setValue={setpricemax}
                                            value={pricemax}
                                            name="mb_phone"
                                            style={{
                                                paddingRight: 40, textAlign: 'right'
                                            }}
                                        />                                                            
                                    </div>
                                </div>
                            </div>
                            <div>
                                <div className='titleTxt margint12' style={{ display:"flex", gap:10}}>
                                    {category_1*1 === 3 ? '연면적' : '전용면적'}
                                    <Radios
                                        linetype={'radioimg'}
                                        values={areatype}
                                        setvalues={setareatype} 
                                        namevalue={[
                                            {names: "평", values: 1},
                                            {names: "㎡", values: 2}
                                        ]}
                                        fontweights={400}
                                        fontSizes={14}
                                        sizes={20}
                                    />
                                </div>
                                <div>
                                    <div>
                                        <Input 
                                            valid={'num'}
                                            className={`inputs`}
                                            rightplaceholder={areatype === 1 ? "평":"㎡"} // 평/㎡ 처리
                                            setValue={setareamin}
                                            value={areamin}
                                            name="mb_phone"
                                            style={{
                                                paddingRight: 40, textAlign: 'right'
                                            }}
                                        />                                                           
                                    </div>
                                    <div>~</div>
                                    <div>
                                        <Input 
                                            valid={'num'}
                                            className={`inputs`}
                                            rightplaceholder={areatype === 1 ? "평": "㎡"}
                                            setValue={setareamax}
                                            value={areamax}
                                            name="mb_phone"
                                            style={{
                                                paddingRight: 40, textAlign: 'right'
                                            }}
                                        />                                                            
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="filterlines" style={{ margin: '10px 0px'}}></div>

                <div className="filteraddrarea">
                    <div style={{ marginBottom: 12 }}>소재지</div>
                    <AddrSelector
                        listselecterviewerlist={listselecterviewerlist}
                        setlistselecterviewerlist={setlistselecterviewerlist}
                    /> 
                </div>
                <div className='selstickdelarea margint20'>
                    {listselecterviewerlist?.length > 0 && listselecterviewerlist?.map((x, i) => {
                        return (
                            <button type="button" 
                                key={i}
                                onClick={() => {
                                    setlistselecterviewerlist(listselecterviewerlist?.filter(item => item?.viewernames !== x?.viewernames));  
                                }}                                                    
                            >
                                {x?.viewernames}
                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                    <path fillRule="evenodd" clipRule="evenodd" d="M3.52851 3.52851C3.78886 3.26816 4.21097 3.26816 4.47132 3.52851L7.99992 7.05711L11.5285 3.52851C11.7889 3.26816 12.211 3.26816 12.4713 3.52851C12.7317 3.78886 12.7317 4.21097 12.4713 4.47132L8.94273 7.99992L12.4713 11.5285C12.7317 11.7889 12.7317 12.211 12.4713 12.4713C12.211 12.7317 11.7889 12.7317 11.5285 12.4713L7.99992 8.94273L4.47132 12.4713C4.21097 12.7317 3.78886 12.7317 3.52851 12.4713C3.26816 12.211 3.26816 11.7889 3.52851 11.5285L7.05711 7.99992L3.52851 4.47132C3.26816 4.21097 3.26816 3.78886 3.52851 3.52851Z" fill="#999999"/>
                                </svg>                                
                            </button>
                        );
                    })}
                </div>      
                <div className="filterlines" style={{ margin: '10px 0px'}}></div>      
                <div className="filterbuttonsarea">
                    <div>
                        <Button
                            onPress={() => {
                                setlistsetbuttonactive(false);
                            }}                    
                            buttonTxt={'검색하기'}
                        />
                    </div>
                    <div>
                        <Button
                            titleimgs={`./images/icons/loop-left-line-purple.svg`}
                            buttonTxt={'초기화'}
                            className={'linenormalbutton'}
                            onPress={() => {
                                searchClear();
                            }}                             
                        />
                    </div>
                </div>                        
            </div>
        </div>
        }
        
        {listsetbuttonactive === true &&
        <div className="filterpoparea padding32 mobileViewer">
            <div className="ProductpopTitle " style={{ marginBottom: 20 }}>
                <span style={{ display: 'inline-block', width: 25}}></span>
                <span style={{ fontSize: 16 }}>필터</span>
                <button
                    onClick={() => {
                        setlistsetbuttonactive(false);
                    }}
                >
                    <img src="./images/icons/x.svg" />                                            
                </button>
            </div>            
            <div className="filterSelarea">
                {/* <div className='filterselect'>
                    <Select 
                        setValues={() => {}}
                        values={''}
                        selectData={[
                            {labels: '고객 조건으로 설정', values: '0'},
                        ]}
                    />
                </div> */}
                <div className='filterSelarealists '>
                    <div className='filterSelarealists1'>
                        <div className='titleTxt'>거래형태</div>
                        {/* <div>매매와 임대는 동시에 선택할 수 없습니다.</div> */}
                        <div>
                            <Radios
                                linetype={'checkimg'}
                                values={sell_type}
                                setvalues={setsell_type}
                                namevalue={[
                                    {names: '매매', values: '매매'},
                                    {names: '전세', values: '전세'},
                                    {names: '월세', values: '월세'},
                                ]}
                                fontweights={400}
                                fontSizes={15}
                                sizes={21}
                            />                                                
                        </div>
                    </div>
                    <div className='filterSelarealists2'>
                        <div className='titleTxt'>매물 종류</div>
                        <div>
                            <Radios
                                linetype={'radioimg'}
                                values={category_1}
                                setvalues={(e) => {
                                    setcategory_1(e*1);
                                    setcategory_2(category_2_setting?.filter((x2, i2) => (x2.category_1*1 === e*1))[0]?.values);
                                }} 
                                namevalue={category_1_OptionConsts}
                                fontweights={400}
                                fontSizes={15}
                                sizes={21}
                            />                                                
                        </div>
                        <div>
                            <Radios
                                linetype={'checkimg'}
                                values={category_2}
                                setvalues={setcategory_2}
                                namevalue={category_2_setting?.filter((x, i) => x?.category_1*1 === category_1*1)}
                                fontweights={400}
                                fontSizes={15}
                                sizes={21}
                            />                                                
                        </div>
                    </div>
                    <div className='filterSelarealists3'>
                        <div>
                            <div className='titleTxt'>{sell_type === '매매' ? '매매가' : '보증금'}</div>
                            <div>
                                <div>
                                    <Input 
                                        valid={'num'}
                                        className={`inputs`}
                                        rightplaceholder="만원"
                                        setValue={setpricemin}
                                        value={pricemin}
                                        name="mb_phone"
                                        style={{
                                            paddingRight: 40, textAlign: 'right'
                                        }}
                                    />                                                           
                                </div>
                                <div>~</div>
                                <div>
                                    <Input 
                                        valid={'num'}
                                        className={`inputs`}
                                        rightplaceholder="만원"
                                        setValue={setpricemax}
                                        value={pricemax}
                                        name="mb_phone"
                                        style={{
                                            paddingRight: 40, textAlign: 'right'
                                        }}
                                    />                                                            
                                </div>
                            </div>
                        </div>
                        <div>
                            <div className='titleTxt margint12'>전용면적</div>
                            <div>
                                <div>
                                    <Input 
                                        valid={'num'}
                                        className={`inputs`}
                                        rightplaceholder="㎡"
                                        setValue={setareamin}
                                        value={areamin}
                                        name="mb_phone"
                                        style={{
                                            paddingRight: 40, textAlign: 'right'
                                        }}
                                    />                                                           
                                </div>
                                <div>~</div>
                                <div>
                                    <Input 
                                        valid={'num'}
                                        className={`inputs`}
                                        rightplaceholder="㎡"
                                        setValue={setareamax}
                                        value={areamax}
                                        name="mb_phone"
                                        style={{
                                            paddingRight: 40, textAlign: 'right'
                                        }}
                                    />                                                            
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="filterlines" style={{ margin: '10px 0px'}}></div>

            <div className="filteraddrarea">
                <div style={{ marginBottom: 12 }}>소재지</div>
                <AddrSelector
                    listselecterviewerlist={listselecterviewerlist}
                    setlistselecterviewerlist={setlistselecterviewerlist}
                /> 
            </div>
            <div className='selstickdelarea margint20'>
                {listselecterviewerlist?.length > 0 && listselecterviewerlist?.map((x, i) => {
                    return (
                        <button type="button" 
                            key={i}
                            onClick={() => {
                                setlistselecterviewerlist(listselecterviewerlist?.filter(item => item?.viewernames !== x?.viewernames));  
                            }}                                                    
                        >
                            {x?.viewernames}
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                <path fillRule="evenodd" clipRule="evenodd" d="M3.52851 3.52851C3.78886 3.26816 4.21097 3.26816 4.47132 3.52851L7.99992 7.05711L11.5285 3.52851C11.7889 3.26816 12.211 3.26816 12.4713 3.52851C12.7317 3.78886 12.7317 4.21097 12.4713 4.47132L8.94273 7.99992L12.4713 11.5285C12.7317 11.7889 12.7317 12.211 12.4713 12.4713C12.211 12.7317 11.7889 12.7317 11.5285 12.4713L7.99992 8.94273L4.47132 12.4713C4.21097 12.7317 3.78886 12.7317 3.52851 12.4713C3.26816 12.211 3.26816 11.7889 3.52851 11.5285L7.05711 7.99992L3.52851 4.47132C3.26816 4.21097 3.26816 3.78886 3.52851 3.52851Z" fill="#999999"/>
                            </svg>                                
                        </button>
                    );
                })}
            </div>      
            <div className="filterlines" style={{ margin: '10px 0px'}}></div>      
            <div className="filterbuttonsarea">
                <div>
                    <Button
                        onPress={() => {
                            setlistsetbuttonactive(false);
                        }}                    
                        buttonTxt={'검색하기'}
                    />
                </div>
                <div>
                    <Button
                        titleimgs={`./images/icons/loop-left-line-purple.svg`}
                        buttonTxt={'초기화'}
                        className={'linenormalbutton'}
                        onPress={() => {
                            searchClear();
                        }}                             
                    />
                </div>
            </div>       
        </div>
        }
                

        {/* {memberinfos?.jp_item_send*1 === 1 ?
        <button 
            className='pcviewflex'
            type="button"
            style={{
                fontWeight: 700,
                color: '#000',
                display: 'flex', alignItems: 'center', justifyContent: 'center',
                position: 'absolute', left: 10, bottom: 10,
                padding: "10px 20px", height: 50, backgroundColor: '#ACAED9', borderRadius: 100,
                display: 'flex', alignItems: 'center', justifyContent: 'center'                        
            }}
            onClick={() => {


                const PopComponents = () => {
                    return (
                        <div className='productsendArea' style={{ width: 420, display: 'flex', alignItems: 'center', justifyContent: 'center', flexDirection: 'column'}}>
                            <div style={{ fontSize: 20, color: '#6164A5'}}><span style={{ color: 'orange'}}>아싸 점포거래소</span>에서 홍보를 중단합니다.</div>
                            <div style={{ textAlign: 'center', fontSize: 15, fontWeight: 700}}>* 연동된 모든 매물이 아싸 점포거래소에서 미노출 됩니다.</div>
                            <div style={{ textAlign: 'center', fontSize: 15, fontWeight: 700}}>* 아싸 점포거래소에 적용까지 최대 1시간이 소요 됩니다.</div>
                            <div style={{ textAlign: 'center', fontSize: 15, fontWeight: 700, justifyContent: 'center'}}>* 문의: 모두의 매물 고객센터 또는 아싸점포거래소 고객센터</div>
                        </div>
                    );
                }
                dispatch(
                    open({
                        component: <PopComponents />,
                        title: '알림',
                        button: "홍보 중단하기",
                        titleviewer: true,
                        alert: false,
                        onPress: () => {
                            dispatch(loadingflas({ loading: true }));
                            let sender = {
                                jp_item_send: 0
                            }
                            APIS.postData('/v1/auth/outsideupdate', sender).then(({ data }) => {
                                if(data){
                                    dispatch(close());
                                    listopen();
                                    getMemberinfo((e) => {
                                        setmemberinfos(e);
                                    });
                                }
                            }).catch(({ response }) => {
                                //console.log('???');
                                dispatch(close());
                                dispatch(
                                    open({
                                        component: response?.data?.msg,
                                        title: '알림',
                                        button: "확인",
                                        titleviewer: true,
                                        alert: true,
                                        onPress: () => {
                                            dispatch(close());  
                                        },
                                    })
                                );

                                const { data } = response;
                            }).finally(() => {
                                dispatch(loadingflas({ loading: false }));
                            });   
                        },
                    })
                );
            }}
        >
            <span style={{ color: '#fff'}}>아싸점포거래소</span>
            <span>에 상업용 부동산</span>
            <span style={{ color: '#fff'}}>매물 홍보하기</span>
            <span style={{ color: '#fff', width: 50, backgroundColor: '#6164A5', padding: '3px 5px', borderRadius: 100, marginLeft: 10}}>ON</span>
        </button>
        :
        <button 
            className='pcviewflex'
            type="button"
            style={{
                fontWeight: 700,
                color: '#000',
                display: 'flex', alignItems: 'center', justifyContent: 'center',
                position: 'absolute', left: 10, bottom: 10,
                padding: "10px 20px", height: 50, backgroundColor: '#EFEFEF', borderRadius: 100,
                display: 'flex', alignItems: 'center', justifyContent: 'center'                        
            }}
            onClick={() => {
                dispatch(loadingflas({ loading: true }));
                let sender = {
                    jp_item_send: 1
                }                
                APIS.postData('/v1/auth/outsideupdate', sender).then(({ data }) => {
                    if(data){
                        listopen();
                        getMemberinfo((e) => {
                            setmemberinfos(e);
                        });
                    }
                }).catch(({ response }) => {
                    const { data } = response;
                    dispatch(close());
                    dispatch(
                        open({
                            component: data?.msg,
                            title: '알림',
                            button: "확인",
                            titleviewer: true,
                            alert: true,
                            onPress: () => {
                                dispatch(close());  
                            },
                        })
                    );
                }).finally(() => {
                    dispatch(loadingflas({ loading: false }));
                });  
             
            }}
        >
            <span style={{ color: '#6164A5'}}>아싸점포거래소</span>
            <span>에 상업용 부동산</span>
            <span style={{ color: '#6164A5'}}> 매물 홍보하기</span>
            <span style={{ color: '#fff', width: 50, backgroundColor: '#9E9E9E', padding: '3px 5px', borderRadius: 100, marginLeft: 10}}>OFF</span>
        </button>
        } */}
        </>
    )
}
